import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Config from '../Config.json';
import Tooltip from '@mui/material/Tooltip';
// import { makeStyles } from "@mui/styles";

import "/node_modules/flag-icons/css/flag-icons.min.css";

export default function LanguageSelector(props) {

  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    // setAge(event.target.value);
    console.log("setting flag to",event.target.value)
    props.updateFlag(event.target.value);
  };

  const iconStyle = { position: 'absolute', left:10,right:50, pointerEvents : 'none'};

  return (
    <FormControl sx={{  maxWidth: 120,  }} size="small">
        
      <InputLabel id="demo-select-small-label"></InputLabel>
      
      <Tooltip title={Config.langMappingsObj[Config.countryLangMapping[props.flag]]} placement="left-end">
      <Select
        disableUnderline 
        variant="standard"
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={""}
        label={""}
        onChange={handleChange}
        labelStyle={{ color: 'green' }}
        sx={{mb:1, }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
        IconComponent={() => (
            <span className={"fi fi-" + props.flag} style={iconStyle} />
          )}
      >
        
        {
            Config.languageMappings.map((obj) => <MenuItem value={obj.langCode}>{obj.langName}</MenuItem>)
        }
      </Select>
      </Tooltip>
    </FormControl>
  );
}